var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { color, alignItems, borderBottom, borderColor, display, flexDirection, flexWrap, justifyContent, space, } from 'styled-system';
import { getCMSTrackerProps } from '../../common/tracking/getTrackerProps';
import { Text } from '../../common/components/Text';
import { LinkStyles } from '../../common/components/Link';
import { FlexJustifyContent, Grid, GridItem, } from '../../common/components/Grid';
import { LocaleProviderPropTypes, withLocale, } from '../../common/providers/LocaleProvider';
import NewsletterForm from './NewsletterForm';
var NewsletterSignupGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), color, justifyContent);
NewsletterSignupGrid.defaultProps = {
    bg: 'gray.2',
    mb: [3, 4, null, 5],
    justifyContent: FlexJustifyContent.CENTER,
};
var NewsletterSignupContainer = styled(GridItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  box-sizing: border-box;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  box-sizing: border-box;\n"])), display, flexDirection, flexWrap, justifyContent, alignItems);
NewsletterSignupContainer.defaultProps = {
    display: 'flex',
    flexDirection: ['column', null, 'row'],
    flexWrap: ['auto', 'nowrap'],
    justifyContent: ['auto', 'space-between'],
    alignItems: 'center',
    py: ['22px', 4, null, 5],
    px: ['14px', '12px', 0],
    w: 1,
};
var VoucherContainerGrid = styled(GridItem)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), display, flexDirection, alignItems);
VoucherContainerGrid.defaultProps = {
    display: 'flex',
    flexDirection: ['column', null, 'row'],
    alignItems: 'center',
};
var Voucher = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  flex: none;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  flex: none;\n"])), display, flexDirection, alignItems, borderBottom, borderColor, space);
Voucher.defaultProps = {
    display: ['none', null, 'flex'],
    flexDirection: 'column',
    alignItems: 'center',
    borderBottom: '2px solid',
    borderColor: 'brand.normal',
    mr: [0, 4],
    mb: [4, null, 0],
};
var CommonText = styled(Text)(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
CommonText.defaultProps = {
    as: 'p',
    color: 'text',
    fontSize: 5,
    fontWeight: 'bold',
    lineHeight: '26px',
    textAlign: 'center',
    mt: 0,
    mb: 0,
};
var Amount = styled(CommonText)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  & > span {\n    font-size: 36px;\n  }\n"], ["\n  & > span {\n    font-size: 36px;\n  }\n"])));
var Label = styled(CommonText)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  &:after {\n    content: '*';\n    vertical-align: baseline;\n  }\n"], ["\n  &:after {\n    content: '*';\n    vertical-align: baseline;\n  }\n"])));
Label.defaultProps = __assign({}, CommonText.defaultProps, { fontSize: [5, null, '22px', '26px'], lineHeight: ['28px', null, null, 4], fontWeight: 600 });
var FormContainerGrid = styled(GridItem)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), display, flexDirection, alignItems);
FormContainerGrid.defaultProps = {
    pt: [2, null, 0],
    pr: [2, '12px', 0],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};
var TextContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n  text-align: center;\n  line-height: 24px;\n  margin: 0 auto;\n"], ["\n  width: 100%;\n  text-align: center;\n  line-height: 24px;\n  margin: 0 auto;\n"])));
var Message = styled(CommonText)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  & > a {\n    ", ";\n  }\n"], ["\n  & > a {\n    ",
    ";\n  }\n"])), function (props) {
    return LinkStyles(__assign({ styled: true, textDecoration: 'underline' }, props));
});
Message.defaultProps = __assign({}, CommonText.defaultProps, { fontSize: [4, null, null, 5], lineHeight: 3, fontWeight: 'normal' });
var Disclaimer = styled(CommonText)(templateObject_11 || (templateObject_11 = __makeTemplateObject([""], [""])));
Disclaimer.defaultProps = __assign({}, CommonText.defaultProps, { fontSize: [3, null, null, 4], fontWeight: 'normal', mt: [3, '12px', 2] });
var NewsletterSignup = /** @class */ (function (_super) {
    __extends(NewsletterSignup, _super);
    function NewsletterSignup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NewsletterSignup.prototype.render = function () {
        var _a = this.props, l10n = _a.l10n, _b = _a.voucher, amount = _b.amount, currency = _b.currency, label = _b.label, headline = _a.headline, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
        var htmlMessage = l10n.r(l10n.t('h24_newsletter_message'), {
            h24_newsletter_message_link: l10n.t('h24_newsletter_message_link'),
            h24_newsletter_message_link_url: l10n.prefix.t('h24_newsletter_message_link_url'),
        });
        var isCountryWithCurrencyFirst = l10n && (l10n.locale === 'nl_BE' || l10n.locale === 'nl_NL');
        return (React.createElement(NewsletterSignupGrid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
            React.createElement(NewsletterSignupContainer, null,
                React.createElement(VoucherContainerGrid, { w: [1, null, 7 / 12] },
                    React.createElement(Voucher, null,
                        isCountryWithCurrencyFirst ? (React.createElement(Amount, null,
                            currency,
                            " ",
                            React.createElement("span", null, amount))) : (React.createElement(Amount, null,
                            React.createElement("span", null, amount),
                            " ",
                            currency)),
                        React.createElement(Label, null, label)),
                    React.createElement(TextContainer, null,
                        React.createElement(CommonText, null, headline),
                        React.createElement(Message, __assign({}, getCMSTrackerProps({
                            dangerouslySetInnerHTML: { __html: htmlMessage },
                        }, {
                            event: 'footerTracking',
                            eventData: {
                                placement: 'newsletterSignup',
                                labelIdentifier: 'h24_newsletter_message_link',
                            },
                        }, ['A']))))),
                React.createElement(FormContainerGrid, { w: [1, 6 / 8, 5 / 12] },
                    React.createElement(NewsletterForm, null),
                    React.createElement(Disclaimer, { dangerouslySetInnerHTML: {
                            __html: l10n.t('h24_newsletter_voucher_disclaimer'),
                        } })))));
    };
    NewsletterSignup.propTypes = {
        /** Locale context. */
        l10n: LocaleProviderPropTypes,
        /** Voucher */
        voucher: PropTypes.shape({
            /** Voucher's amount */
            amount: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
            /** Voucher's currency */
            currency: PropTypes.string,
            /** Voucher's label */
            label: PropTypes.string,
        }).isRequired,
        /** Headline of the main text  */
        headline: PropTypes.string,
        /** Should the max width be capped by current Reboot max width (default: true) */
        __legacy_shop_reboot_max_width: PropTypes.bool,
    };
    NewsletterSignup.defaultProps = {
        voucher: {
            amount: '20',
            currency: '€',
            label: 'Gutschein',
        },
        headline: 'Jetzt 20 € Gutschein sichern',
        __legacy_shop_reboot_max_width: true,
    };
    return NewsletterSignup;
}(React.Component));
export default withLocale(NewsletterSignup);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
